var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"md-ripple","appear":""}},[_c('span',{staticClass:"md-ripple-wave"})])}
var staticRenderFns = []

export { render, staticRenderFns }